export const TITLE = 'Welcome to MobileMonkey';
export const SUB_TITLE = `Let's get started by connecting your first Facebook Page.
                          Don't worry! We won't start sending messages for you just yet.`;

export const getWelcomeText = (pageName: string) => {
  return `Welcome to ${pageName}! Can we send you promotional updates?`;
};

export const DEFAULT_FORM_VALUES = {
  optInButtonText: 'Sure!',
  optOutButtonText: 'No Thanks',
  optInResponseText: 'Great',
  optOutResponseText: 'Oh well. Thanks anyways.',
};
